var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon=sliders-04"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3 6.6665L13 6.6665M13 6.6665C13 8.04722 14.1193 9.1665 15.5 9.1665C16.8807 9.1665 18 8.04722 18 6.6665C18 5.28579 16.8807 4.1665 15.5 4.1665C14.1193 4.1665 13 5.28579 13 6.6665ZM8 13.3332L18 13.3332M8 13.3332C8 14.7139 6.88071 15.8332 5.5 15.8332C4.11929 15.8332 3 14.7139 3 13.3332C3 11.9525 4.11929 10.8332 5.5 10.8332C6.88071 10.8332 8 11.9525 8 13.3332Z",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/SettingsIcon.1782c3e05db7b0d554c03d0d2a411fab.svg";
export { ForwardRef as ReactComponent };